import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times.svg'
import modalService from '@/services/modal.service'
import faq from '@/faq.json'
import './FaqModal.scoped.sass'

export default function FaqModal () {
  return (
    <div className='faq-modal'>
      <div className='faq-header'>
        <h2>Frequently asked questions</h2>
        <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
      </div>
      <div className='faq-body'>
        {faq.map((item, i) => (
          <section key={i} className='faq-entry'>
            <div className='faq-q'>{item.q}</div>
            <div className='faq-a'>{item.a}</div>
          </section>
        ))}
      </div>
    </div>
  )
}
